export default {
    namespaced: true,
    state: {
        user: null,
    },
    getters: {
        getUser: state => {
            return state.user;
        },
    },
    mutations: {
        changeUser: (state, callback) => {
            state.user = callback;
            if(state.user.role_id == 2){
                state.admin = true;
            }
        },

        changeUserImage: (state, callback) => {
            state.user.image = callback;
        },

        clearUser: state => {
            state.user = null;
        },

        changeDarkTheme: (state, callback) => {
            state.user.dark_theme = callback;
        },
    },
    actions: {
        changeUser: (context, callback) => {
            context.commit('changeUser', callback);
        },

        changeUserImage: (context, callback) => {
            context.commit('changeUserImage', callback);
        },

        clearUser: context => {
            context.commit('clearUser');
        },

        changeDarkTheme: (context, callback) => {
            context.commit('changeDarkTheme', callback);
        },
    },
};
